import React, { useState } from 'react'
import axios from 'axios';
import { AiFillDelete } from 'react-icons/ai'
import Swal from 'sweetalert2'
import "./ToDoEnd.min.css";
import { ipAddress } from '../../ipAddress';

interface Props {
  task: Task;
}

interface Task {
  name: string,
  id: number,
  isDone: number,
  dateEnd: string,
  toDoGroupId: number
}

const OneTaskEnd: React.FC<Props> = ({ task }) => {

  

  const deleteThing = (id: number) => {
   
    Swal.fire({
      title: 'Czy jesteś pewien?',
      text: "Element zostanie usunięty",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, move it!',
      heightAuto: false,

    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(ipAddress + '/deleteTask', {
          id: id,
        })
      }
    })

      .then((response) => {

      })

      .catch(function (error) {
        console.log("error!")

      })
  }

  


  const handleChange = (id: number, isDone: number) => {
    if (isDone == 1) {
      isDone = 0
    } else {
      isDone = 1
    }
    Swal.fire({
      title: 'Czy jesteś pewien?',
      text: "Element zostanie przeniesony do zaplanowanych",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, move it!',
      heightAuto: false,

    }).then((result) => {
      if (result.isConfirmed) {

    axios.post(ipAddress + '/doneTask', {
      id: id,
      isDone: isDone,
      dateEnd: ''
    })
  }
})


  };

  return (
    <div>
      {

        <div className='tasksList'>

          <input type="checkbox"
          className='checkbox'
            checked={true}
            onChange={() => handleChange(task.id, task.isDone)}
          ></input>
          <s className='description'> {task.name}  </s>


          <span className='delete' onClick={() => deleteThing(task.id)}><AiFillDelete /></span>


        </div>



      }





    </div>
  )
}

export default OneTaskEnd